// LUMINA · pages/vajra/admin/PathManager.jsx
// Phase 59D: Staff — 修行次第节点查看 + 弟子进度管理

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, TXT, TXT2 } from '../constants';

const TRADITION_LABELS = {
  gelug:         "格鲁道次第",
  nyingma:       "宁玛九乘",
  drikung_kagyu: "止贡那若六法",
  sakya:         "萨迦道果",
  jonang:        "觉囊时轮",
};

const STATUS_COLORS = {
  not_started: TXT2,
  in_progress: "#d97706",
  completed:   "#065f46",
};

const lbl = { fontSize: 11, color: TXT2, marginBottom: 3, display: "block" };
const inp = {
  width: "100%", padding: "5px 8px", borderRadius: 5,
  border: "1px solid rgba(0,0,0,0.12)", fontSize: 12,
  boxSizing: "border-box", background: "#fff", marginBottom: 8,
};

export default function PathManager({ token, headers, memberList }) {
  const [nodes, setNodes]                   = useState([]);
  const [selectedTradition, setSelectedTradition] = useState("gelug");
  const [selectedMember, setSelectedMember] = useState("");
  const [memberProgress, setMemberProgress] = useState({});
  const [msg, setMsg]                       = useState("");

  const loadNodes = useCallback(async () => {
    try {
      const r = await fetch(`${API}/vajra/staff/path-nodes`, { headers });
      if (r.ok) setNodes(await r.json());
    } catch {}
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { loadNodes(); }, [loadNodes]);

  const updateProgress = async (nodeId, status) => {
    if (!selectedMember) { setMsg("请先选择弟子"); return; }
    try {
      const r = await fetch(
        `${API}/vajra/staff/members/${selectedMember}/progress/${nodeId}`,
        { method: "PATCH", headers, body: JSON.stringify({ status }) }
      );
      if (r.ok) {
        setMemberProgress(prev => ({ ...prev, [nodeId]: status }));
        setMsg("✓ 已更新进度");
      } else {
        setMsg("更新失败");
      }
    } catch { setMsg("网络错误"); }
    setTimeout(() => setMsg(""), 2500);
  };

  const filteredNodes = nodes.filter(n => n.tradition === selectedTradition);

  return (
    <div>
      <div style={{ fontSize: 15, color: GD, marginBottom: 16 }}>修行次第管理</div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
        <div>
          <label style={lbl}>传承</label>
          <select
            value={selectedTradition}
            onChange={e => setSelectedTradition(e.target.value)}
            style={inp}
          >
            {Object.entries(TRADITION_LABELS).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>
        <div>
          <label style={lbl}>选择弟子（可选）</label>
          <select
            value={selectedMember}
            onChange={e => { setSelectedMember(e.target.value); setMemberProgress({}); }}
            style={inp}
          >
            <option value="">— 仅查看节点结构 —</option>
            {(memberList || []).map(m => (
              <option key={m.id} value={m.id}>
                {m.name}{m.dharma_name ? ` (${m.dharma_name})` : ""}
              </option>
            ))}
          </select>
        </div>
      </div>

      {msg && (
        <div style={{
          fontSize: 12, color: "#065f46", padding: "6px 10px",
          background: "rgba(16,185,129,0.08)", borderRadius: 6, marginBottom: 12,
        }}>
          {msg}
        </div>
      )}

      <div style={{ fontSize: 12, color: TXT2, marginBottom: 8 }}>
        {filteredNodes.length} 个节点 · {TRADITION_LABELS[selectedTradition]}
      </div>

      <div style={{ border: "1px solid rgba(0,0,0,0.08)", borderRadius: 8, overflow: "hidden" }}>
        {filteredNodes.length === 0 ? (
          <div style={{ padding: 20, textAlign: "center", color: TXT2, fontSize: 12 }}>
            暂无节点数据，请先运行种子脚本
          </div>
        ) : (
          filteredNodes.map((node, i) => {
            const currentStatus = memberProgress[node.id] || "not_started";
            return (
              <div key={node.id} style={{
                display: "flex", alignItems: "center", gap: 10, padding: "8px 12px",
                background: i % 2 === 0 ? "#fff" : "#fafafa",
                borderBottom: "1px solid rgba(0,0,0,0.05)",
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, color: TXT }}>{node.name_zh}</div>
                  {node.credential_key && (
                    <div style={{ fontSize: 10, color: "#7c3aed", marginTop: 2 }}>
                      🔑 {node.credential_key}
                    </div>
                  )}
                </div>
                {selectedMember ? (
                  <select
                    value={currentStatus}
                    onChange={e => updateProgress(node.id, e.target.value)}
                    style={{
                      fontSize: 10, padding: "2px 6px", borderRadius: 4,
                      border: "1px solid rgba(0,0,0,0.12)",
                      color: STATUS_COLORS[currentStatus] || TXT2,
                    }}
                  >
                    <option value="not_started">未开始</option>
                    <option value="in_progress">进行中</option>
                    <option value="completed">已圆满</option>
                  </select>
                ) : (
                  <span style={{ fontSize: 10, color: TXT2, opacity: 0.6 }}>
                    选择弟子后可编辑
                  </span>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
